import { inject, Injectable } from '@angular/core';
import { DashboardProfileContextService } from '@rma/dashboard/authentication/public/user';
import { cache } from 'decorator-cache-getter';
import { map, Observable, switchMap } from 'rxjs';
import { ProfileDetailsApiService } from './api-profile-details.service';
import { ProfileSummary } from './domain/profile-summary.model';

@Injectable({
  providedIn: 'root',
})
export class ProfileDetailsContextService {
  private readonly profileDetailsApiService = inject(ProfileDetailsApiService);
  private readonly profileContextService = inject(DashboardProfileContextService);

  @cache
  public get profileSummary$(): Observable<ProfileSummary> {
    return this.profileContextService.profileIdentifierWithVertical$.pipe(
      switchMap((ctx) => this.profileDetailsApiService.getProfileDetails(ctx.verticalType, ctx.profileType, ctx.profileCode)),
    );
  }

  @cache
  public get isPartOfTeam$(): Observable<boolean> {
    return this.profileSummary$.pipe(map((summary) => (summary.grouping?.some((grouping) => grouping.type === 'Team') ? true : false)));
  }
}
